import React, { useState, memo } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { withRouter, RouteComponentProps } from 'react-router';

import { IToursConnection, TourOrderByEnum, OrderByDirectionEnum, ICountry, ILocation, withAppStoreValue, ITopToursCategory } from '../../../store';
import { IAroundMe, INearByTour } from '../common';
import { ToursSectionStoreDispatchAction, withToursSectionStoreValue, EToursSectionStateActionTypes } from '../store';

interface ISortMenuToursStoreProps {
    dispatch: ToursSectionStoreDispatchAction
    toursTotal: number
    orderBy: TourOrderByEnum
    orderByDirection: OrderByDirectionEnum
}

interface ISortMenuAppStoreProps {
    selectedTopCategory: ITopToursCategory
}

const SortMenuCore = memo(withRouter((props: RouteComponentProps & ISortMenuToursStoreProps & ISortMenuAppStoreProps) => {
    console.log("Render SortMenu")
    const { t } = useTranslation()

    const { location: { state: { country = undefined, location = undefined, filterByRegion = undefined, aroundMe = undefined, searchText = undefined, nearByTour = undefined } = {} } } = props
    const { selectedTopCategory, toursTotal, orderBy, orderByDirection, dispatch } = props
    const actualCountry = country as ICountry
    const actualLocation = location as ILocation
    const actualAroundMe = aroundMe as IAroundMe
    const actualSearchText = searchText as string
    const actualNearByTour = nearByTour as INearByTour

    const [activeOrderBy, setActiveOrderBy] = useState(orderBy)
    const [activeOrderByDirection, setActiveOrderByDirection] = useState(orderByDirection)

    const handleDone = () => {
        dispatch({ type: EToursSectionStateActionTypes.SetOrderBy, orderBy: activeOrderBy})
        dispatch({ type: EToursSectionStateActionTypes.SetOrderByDirection, orderByDirection: activeOrderByDirection})
        dispatch({ type: EToursSectionStateActionTypes.SetShowSortMenu, showSortMenu: false})
    }

    const handleReset = () => {
        setActiveOrderBy(orderBy)
        setActiveOrderByDirection(orderByDirection)
    }

    return (
        <>
            <div className="sort-menu">
                <div className="page-title">
                    <h4 className={'m-tb5'}>
                        {toursTotal} {selectedTopCategory && t(selectedTopCategory.name)} {actualNearByTour ? `${t('found around')} '${actualNearByTour.tour.title}'` : actualAroundMe ? t('found around me') : t('found in')} {actualCountry && actualCountry.title} {actualLocation && `, ${actualLocation.region}`} {actualLocation && !filterByRegion && `, ${actualLocation.city}`} {actualSearchText && `${t('for')} '${actualSearchText}'`}
                    </h4>
                </div>
                <label style={{fontSize: '1.25rem', fontWeight: 500}}>{t('Sort by')}: </label>
                <div className="sort-option-container">
                    {[{ orderBy: TourOrderByEnum.date, name: 'Date' }, { orderBy: TourOrderByEnum.title, name: 'Title' }, { orderBy: TourOrderByEnum.views, name: 'Views' },].map(item => (
                        <button key={item.name} className={classNames('sort-option', { active: activeOrderBy === item.orderBy })} onClick={() => setActiveOrderBy(item.orderBy)}>{t(item.name)}</button>
                    ))}
                </div>
                <div className="sort-option-container">
                    {[{ orderDir: OrderByDirectionEnum.asc, name: 'Asc'}, { orderDir: OrderByDirectionEnum.desc, name: 'Desc'}].map(item => (
                        <button key={item.name} className={classNames('sort-option', { active: activeOrderByDirection === item.orderDir })} onClick={() => setActiveOrderByDirection(item.orderDir)}>{t(item.name)}</button>
                    ))}
                </div>
                <div className="sort-bottom">
                    <button onClick={handleDone} className="cta">{t('Apply Filter')}</button>
                    <button onClick={handleReset} className="cta-small cta cta-back">{t('Reset Filter')}</button>
                </div>
            </div>
        </>
    )
}))

const SortMenu = withAppStoreValue(withToursSectionStoreValue<ISortMenuAppStoreProps & ISortMenuToursStoreProps>(SortMenuCore, ['dispatch', 'toursTotal', 'orderBy', 'orderByDirection']), ['categories.selectedTopCategory'])


interface ISortMenuContainerToursStoreProps {
    showSortMenu: boolean
}

export const SortMenuContainer = withToursSectionStoreValue<ISortMenuContainerToursStoreProps>(memo(({ showSortMenu } : ISortMenuContainerToursStoreProps) => (
    showSortMenu ? <SortMenu /> : null
)), ['showSortMenu'])